import React, { forwardRef } from 'react';
import cx from 'classnames';

import useDevice from '@/hooks/useDevice';

import styles from './MenuBurger.module.sass';

interface MenuBurgerProps {
  isActive: boolean;
  onClick: () => void;
}

export const MenuBurger = forwardRef<HTMLButtonElement | null, MenuBurgerProps>(
  (props, ref) => {
    const { isMobile } = useDevice();
    const { isActive = false, onClick } = props;

    const classes = cx(styles.burger, {
      [`${styles['is-active']}`]: isActive,
    });

    if (!isMobile) return null;

    return (
      <button ref={ref} type="button" className={classes} onClick={onClick}>
        <span className={styles.burger__in}>
          <i />
          <i />
          <i />
        </span>
      </button>
    );
  },
);

export default MenuBurger;
